import axios from 'axios';
import { useState, useEffect } from 'react';
import { OptionSet } from '../models/SkillsInterfaces';

export const useGetCompanyValues = () => {
  const [companyValues, setCompanyValues] = useState<OptionSet[]>();
  const [loadingCompanyValues, setLoadingCompanyValues] = useState(false);

  const getCompanyValues = async () => {
    setLoadingCompanyValues(true);
    try {
      const response = await axios.get('api/option-sets/company-values');
      setCompanyValues(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingCompanyValues(false);
    }
  };

  useEffect(() => {
    getCompanyValues();
  }, []);

  return { companyValues, loadingCompanyValues };
};
